import React, { useState } from "react";
import { get } from "lodash-es";
import { observer } from "mobx-react";
import { Button, Box, Text } from "@chakra-ui/core";
import { Cell, Column, Table } from "@reactivepad/blueprint-table";
import a2z from "a2zzz";

var COLUMN_COUNT = 40;
var generator = a2z.limit(COLUMN_COUNT);

var headers = [];
for (var _iterator = generator, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
  var _ref;

  if (_isArray) {
    if (_i >= _iterator.length) break;
    _ref = _iterator[_i++];
  } else {
    _i = _iterator.next();
    if (_i.done) break;
    _ref = _i.value;
  }

  var label = _ref;

  headers.push(label.toUpperCase());
}

function SheetRangePicker(_ref2) {
  var spreadsheet = _ref2.spreadsheet,
      handleClose = _ref2.handleClose,
      handleSave = _ref2.handleSave;

  var _useState = useState(null),
      range = _useState[0],
      setRange = _useState[1];

  var _spreadsheet$sheets = spreadsheet.sheets,
      sheet = _spreadsheet$sheets[0];

  var rowData = get(sheet, "data[0].rowData") || [];
  var rowCount = rowData.length;
  var colCount = Math.max.apply(Math, rowData.map(function (row) {
    return get(row, "values.length") || 0;
  }));

  var cellRenderer = function cellRenderer(rowIndex, colIndex) {
    var val = get(rowData, rowIndex + ".values[" + colIndex + "].formattedValue");

    if (!val) {
      return React.createElement(Cell, null);
    }

    return React.createElement(
      Cell,
      null,
      val
    );
  };

  var onSelection = function onSelection(range) {
    if (!range || range.length === 0) {
      return;
    }
    var _range$ = range[0],
        _range$$rows = _range$.rows,
        rows = _range$$rows === undefined ? [] : _range$$rows,
        _range$$cols = _range$.cols,
        cols = _range$$cols === undefined ? [] : _range$$cols;

    var x1 = "" + headers[cols[0]] + (rows[0] + 1);
    var x2 = "" + headers[cols[1]] + (rows[1] + 1);
    var final = x1 + ":" + x2;
    setRange(final);
  };

  var onSubmit = function onSubmit() {
    handleSave({
      spreadId: spreadsheet.spreadsheetId,
      spreadName: spreadsheet.properties.title,
      sheetId: sheet.properties.sheetId,
      sheetName: sheet.properties.title,
      range: range
    });
    handleClose();
  };

  return React.createElement(
    Box,
    { mb: 3 },
    React.createElement(
      Text,
      { mb: 2 },
      "Selected data range: ",
      React.createElement(
        "strong",
        null,
        range
      )
    ),
    React.createElement(
      Table,
      { numRows: rowCount + 5, onSelection: onSelection },
      headers.slice(0, colCount + 5).map(function (h) {
        return React.createElement(Column, { key: h, name: h, cellRenderer: cellRenderer });
      })
    ),
    React.createElement(
      Box,
      { mt: 3, d: "flex", justifyContent: "flex-end" },
      React.createElement(
        Button,
        { onClick: handleClose, mr: 3 },
        "Cancel"
      ),
      React.createElement(
        Button,
        { onClick: onSubmit, disabled: !range, variant: "solid" },
        "Save"
      )
    )
  );
}

export default observer(SheetRangePicker);